import React, { useEffect, useState } from "react";
import { MDBCollapse, MDBBtn } from "mdb-react-ui-kit";
import nextLeft from "../../../images/next-left.png";

const Collapse = (props) => {
  const [showCollapseInfo, setshowCollapseInfo] = useState(props.open);
  const toggleShow = () => setshowCollapseInfo(!showCollapseInfo);

  return (
    <>
      <div className={props.header == "روزها و ساعات کاری" ? "mb127" : ""}>
        <div
          className={showCollapseInfo ? "borderright-info-collapse" : "d-none"}
        >
          <div></div>
        </div>
        <MDBBtn
          className={
            showCollapseInfo
              ? "buttonCollapse_info_open"
              : "buttonCollapse_info"
          }
          onClick={toggleShow}
        >
          <span className="mt-1">{props.header}</span>
          <img className="img_back_info" src={nextLeft} alt="nextLeft" />
        </MDBBtn>
      </div>
      {showCollapseInfo && (
        <MDBCollapse show={!showCollapseInfo}>{props.children}</MDBCollapse>
      )}
    </>
  );
};

export default Collapse;
